import { render, staticRenderFns } from "./leaf.vue?vue&type=template&id=7d1071dc&"
import script from "./leaf.vue?vue&type=script&lang=js&"
export * from "./leaf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports